import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";

import { I18nContextProvider } from "../context/I18nProvider";
import { ObserverContextProvider } from "../context/Observer";
import { PollContextProvider } from "../context/Poll";
import { FiltersProvider } from "../context/FiltersContext";

import Layout from "../Layout/Layout";
import Loader from "../containers/Loaders/Loader";

/// Wiki de documentacion
/// https://github.com/portinos/TowerTravel-Sports/wiki

import Router from "./Router";

const BASE_URL = process.env.REACT_APP_BASENAME_URL;

const App = () => {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <BrowserRouter basename={BASE_URL}>
          <I18nContextProvider>
            <FiltersProvider>
              <PollContextProvider>
                <ObserverContextProvider>
                  <Layout>
                    <Router />
                  </Layout>
                </ObserverContextProvider>
              </PollContextProvider>
            </FiltersProvider>
          </I18nContextProvider>
        </BrowserRouter>
      </Suspense>
    </>
  );
};

export default App;
